'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WriteEmailDirective = exports.WriteEmailDirective = {
  selector: 'writeEmail',
  restrict: 'A',
  scope: {
    sendEmail: '&'
  },
  transclude: true,
  template: '<div ng-click="we.writeEmail($event)"><ng-transclude></ng-transclude></div>',
  bindToController: true,
  controllerAs: 'we',
  controller: function () {
    function WriteEmailDirectiveCtrl($mdDialog) {
      _classCallCheck(this, WriteEmailDirectiveCtrl);

      this.dialog = $mdDialog;
    }

    _createClass(WriteEmailDirectiveCtrl, [{
      key: 'writeEmail',
      value: function writeEmail(e) {
        var _this = this;

        e.preventDefault();
        e.stopPropagation();

        this.dialog.show({
          controller: function controller($scope) {
            $scope.email = {
              subject: '',
              message: ''
            };
            $scope.cancel = function () {
              return _this.dialog.cancel();
            };
            $scope.send = function (email) {
              _this.sendEmail && _this.sendEmail({ email: email });
              _this.dialog.hide();
            };
          },
          template: require('./write-email-dialog.tmpl.html'),
          parent: angular.element(document.body),
          targetEvent: e,
          clickOutsideToClose: true
        });
      }
    }]);

    return WriteEmailDirectiveCtrl;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./common/directives/write-email/write-email.dir.js
// module id = 475
// module chunks = 0